import React from "react";
import BoolField from "../../../BoolField";
import CalendarField from "../../../CalendarField";
import CheckboxField from "../../../CheckboxField";
import RadioField from "../../../RadioField";
import SectionField from "../../../SectionField";
import DictionaryField from "../../../DictionaryField";
import SqlField from "../../../SqlField";
import TextareaField from "../../../TextareaField";
import TextField from "../../../TextField";
import FileField from "../../../FileField";

export default function GridElementRenderer({
   element,
   elements,
   form,
   initialValue,
   tableDisabled,
   gridFormId,
   isEdited,
   rowDataId,
}) {
   const resolveDependentFields = (arrayOfFields, dependencyType, operation) => {
      let returnValue = false;
      for (const field of arrayOfFields) {
         let dependentFieldValue = getDependentFieldValue(field);
         if (
            isNaN(+dependentFieldValue) && isNaN(+field.value)
               ? field.value === dependentFieldValue
               : +field.value === +dependentFieldValue
         ) {
            returnValue = field[dependencyType] === operation;
         } else {
            return field[dependencyType] !== operation;
         }
      }
      return returnValue;
   };

   const checkIfDisabled = (element) => {
      const { editabilityControls } = element;
      if (editabilityControls && editabilityControls.length > 0) {
         return !resolveDependentFields(editabilityControls, "editable", "editable");
      }
      if (element?.object?.UIP_EDYT === "0") {
         return true;
      }
      return false;
   };

   const getDependentFieldValue = (field) => {
      let fieldValue = form.getFieldValue(field.techname);
      const fieldData = Object.values(elements).find((el) => el.tech_name === field.techname);
      if (fieldData?.type === "select") {
         fieldValue = Object.entries(fieldData.options).find(
            ([key, label]) => label === fieldValue,
         )?.[0];
      }

      if (typeof fieldValue === "boolean") {
         return fieldValue ? "1" : "0";
      }
      return fieldValue || "";
   };

   const propsForAllFields = (element) => {
      return {
         element,
         form,
         initialValue,
         formId: gridFormId,
         isRequired: () => element?.obow === "1",
         isVisible: () => true,
         disabled: tableDisabled || checkIfDisabled(element),
         rowDataId,
         insideGrid: true,
      };
   };

   const renderField = (element) => {
      switch (element?.type) {
         case "text":
            return <TextField {...propsForAllFields(element)} />;
         case "section":
            return <SectionField {...propsForAllFields(element)} />;
         case "sql":
            return <SqlField {...propsForAllFields(element)} />;
         case "textarea":
            return <TextareaField {...propsForAllFields(element)} />;
         case "select":
            return <DictionaryField {...propsForAllFields(element)} />;
         case "calendar":
            return <CalendarField {...propsForAllFields(element)} />;
         case "checkbox":
            return <CheckboxField {...propsForAllFields(element)} />;
         case "file":
            return <FileField {...propsForAllFields(element)} />;
         case "radio":
            return <RadioField {...propsForAllFields(element)} />;
         case "bool":
            return <BoolField {...propsForAllFields(element)} />;
         case "file":
            return <FileField {...propsForAllFields(element)} />;
         default:
            break;
      }
   };

   return <span className={!isEdited ? "not-editable" : ""}>{renderField(element)}</span>;
}
